export const dsColorSystemBlack = "#000000";
export const dsColorSystemBlue = "#0a75e3";
export const dsColorSystemBlueDark = "#07529f";
export const dsColorSystemBlueLight = "#d2ebff";
export const dsColorSystemGreen = "#1f9b85"; // affirmative
export const dsColorSystemGreenDark = "#166c5d";
export const dsColorSystemGreenLight = "#ccf5eb";
export const dsColorSystemOrange = "#dc7c24"; // medium risk
export const dsColorSystemOrangeDark = "#9a5719";
export const dsColorSystemOrangeLight = "#ffe6c8";
export const dsColorSystemRed = "#e02929"; // destructive - high risk
export const dsColorSystemRedDark = "#9d1d1d";
export const dsColorSystemRedLight = "#ffe1e8";
export const dsColorSystemWhite = "#ffffff";
